import { colorsList } from "../../data/colorsList";

export default function TerName({ id, title, onClick }) {
  return (
    <div
      onClick={() => {
        onClick(id, title);
      }}
      style={{
        position: "relative",
        flex: 1,
      }}
    >
      <b style={{ fontSize: "large", color: colorsList.blue }}>{title}</b>
    </div>
  );
}
